import gql from "graphql-tag";

export default gql`
	mutation createGroup($group_id: ID, $users: [ID!]!, $limit: String!, $name: String!) {
		createGroup(groupId: $group_id, users: $users, limit: $limit, name: $name) {
			id
		}
	}
`;
